<template lang="pug">
  .push-item(:class="{canCancel: item.canCancel}" :data-marginBottom="item.marginBottom")
    | {{ item.text }}
    .close(@click.stop="remove")
    component(
      v-if="component"
      :is="component.is"
      v-bind="component.props"
      v-on="component.emits"
      @remove="remove"
    )
</template>

<script>
export default {
  name: 'PushItem',
  props: {
    item: Object,
  },
  computed: {
    component() { return this.item.component; },
  },
  methods: {
    remove() {
      this.$store.commit('push/remove', this.item);
    },
  },
};
</script>

<style scoped lang="scss">
  .push-item {
    width: 100%;
    box-sizing: border-box;
    background: #1E3147;
    opacity: 0.95;
    border-radius: 4px;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    position: relative;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #FFFFFF;

    box-shadow: 0 6px 12px rgba(0, 0, 0, .2);

    .close {
      position: absolute;
      cursor: pointer;
      right: 5px;
      top: 5px;
      width: 10px;
      height: 10px;

      &:before, &:after {
        content: '';
        display: block;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 1px;
        transform: translate(-50%);
        position: absolute;
        background: #FFFFFF;
      }

      &:before {
        transform: translate(-50%) rotate(45deg);
      }
      &:after {
        transform: translate(-50%) rotate(-45deg);
      }
    }
  }
</style>
